/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';

export default class PostRoute extends Route {
  // Services
  @service
  notifications;

  @service
  store;

  model(params) {
    return this.store.findRecord('posts/post', params.post_id, {
      include: 'reactions,comments',
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    this.notifications.markEntityRead(model.id);
  }
}
